"use strict";
const DEFAULT_LOCALE = "en-US";
const PSEUDO_LOCALE = "en-XA";
module.exports = {
    DEFAULT_LOCALE,
    PSEUDO_LOCALE,
};
//# sourceMappingURL=defaultLocale.js.map